import classNames from 'classnames';
import PropTypes from 'prop-types';

import DocList from './DocumentList';
import Media from './Media';
import Modal from '../../Modal';
import Icon from '../../OC/oc-icon';
import Link from '../../OC/oc-link';
import fixTrackVars from '../../helpers/data_track_prop_map';
import htmlableElement from '../../helpers/react-htmlable-element';

const ProductItem = ({ preheading, heading, img, text, url, features, track, compact, documents, availability }) => (
  <div className={compact ? 'itemCompact' : 'item'}>
    <Media img={img} url={url} track={track} title={heading} altText={text}>
      <div className="heading">
        {preheading ? <div className="preHeading">{preheading}</div> : ''}
        <h2 className="h4">
          {url ? (
            <a href={url} className="mainLink" {...fixTrackVars(track)} dangerouslySetInnerHTML={{ __html: heading }} />
          ) : (
            <span className="mainLink" dangerouslySetInnerHTML={{ __html: heading }} />
          )}
        </h2>
      </div>

      {availability ? (
        <div className="availability">
          <Link
            className="availability-open"
            onClick={availability.onOpen}
            analytics={{ track: 'open-modal', 'modal-name': 'Region Availability Modal', 'product-name': heading }}
          >
            <div className="availability-icon" /> <span>View Availability Details</span>
          </Link>
          <Modal open={availability.open} onClose={availability.onClose} data-am-region="Region Availability Modal">
            <h2>Regional Availability</h2>
            {availability.title ? <h4>{availability.title}</h4> : null}
            {availability.description ? <p>{availability.description}</p> : null}
            {availability.table ? (
              <div className="availability-table" dangerouslySetInnerHTML={{ __html: availability.table }} />
            ) : null}
            <a className="availability-pdp-cta" href={url}>
              View Product Details
            </a>
          </Modal>
        </div>
      ) : null}

      {htmlableElement('p', text)}

      {documents && documents.length > 0 && <DocList documents={documents} />}

      {features ? (
        <ul className={classNames('featureList', features.length > 1 && 'multipleFeatureList')}>
          {features.map((name, index) => htmlableElement('li', name, { key: index }))}
        </ul>
      ) : (
        ''
      )}
    </Media>
  </div>
);

ProductItem.propTypes = {
  preheading: PropTypes.string,
  heading: PropTypes.string.isRequired,
  img: PropTypes.string,
  text: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      __html: PropTypes.string,
    }),
  ]),
  url: PropTypes.string,
  features: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.shape({
        __html: PropTypes.string,
      }),
    ])
  ),
  documentType: PropTypes.string,
  documentSize: PropTypes.string,
  compact: PropTypes.bool,
};

export default ProductItem;
